import { useApiQuery } from 'mf_core/query';

export function useSubscriberId() {
  return useApiQuery<any>(
    `/account-management/v1/notifications/subscribers/me`
  );
}
